(function () {
  const drawer = document.querySelector('[data-hah-cart-drawer]');
  const backdrop = document.querySelector('.hah-cart-backdrop');
  if (!drawer || !backdrop || drawer.dataset.hahCartReady === 'true') return;
  drawer.dataset.hahCartReady = 'true';

  const itemsNode = drawer.querySelector('[data-hah-cart-items]');
  const countNode = drawer.querySelector('[data-hah-cart-count]');
  const labelNode = drawer.querySelector('[data-hah-cart-item-label]');
  const subtotalNode = drawer.querySelector('[data-hah-cart-subtotal]');
  const noteNode = drawer.querySelector('[data-hah-cart-note]');
  const noteToggle = drawer.querySelector('[data-hah-cart-note-toggle]');
  const checkoutNode = drawer.querySelector('.hah-cart-checkout');

  const symbols = {
    USD: '$',
    CAD: '$',
    AUD: '$',
    EUR: '€',
    GBP: '£',
    VND: '₫',
    CNY: '¥',
    JPY: '¥'
  };

  let currentCart = null;
  let readSerial = 0;
  let pendingRead = null;
  let pendingChange = null;
  let pendingChangeRead = null;
  const pendingAdds = new WeakSet();
  const uncertainAdds = new WeakSet();
  const previewMigrationAttempts = new Map();
  let previewMigrationCommits = 0;

  function cartEndpoint(name) {
    const root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/';
    return root.replace(/\/?$/, '/') + name;
  }

  function cartState(message, failed) {
    currentCart = null;
    drawer.setAttribute('aria-busy', failed ? 'false' : 'true');
    if (countNode) countNode.textContent = '—';
    if (labelNode) labelNode.textContent = 'items';
    if (subtotalNode) subtotalNode.textContent = '—';
    if (checkoutNode) checkoutNode.style.display = 'none';
    if (itemsNode) itemsNode.innerHTML = `<div class="hah-cart-empty" role="status" aria-live="polite">${escapeHtml(message)}${failed ? ' <a href="/cart" data-hah-cart-page>View cart</a>' : ''}</div>`;
  }

  function invalidateRead() {
    readSerial++;
    const previous = pendingRead;
    pendingRead = null;
    if (previous && previous.controller) previous.controller.abort();
  }

  function validCart(cart) {
    return cart && Array.isArray(cart.items) && Number.isInteger(cart.item_count) && cart.item_count >= 0 &&
      Number.isFinite(cart.total_price) && cart.total_price >= 0;
  }

  function formatMoney(cents, currency) {
    const amount = Number(cents || 0) / 100;
    const symbol = symbols[currency] || `${currency || 'USD'} `;
    if (currency === 'VND' || currency === 'JPY') {
      return `${symbol}${Math.round(amount).toLocaleString()}`;
    }
    return `${symbol}${amount.toFixed(2)}`;
  }

  function formatMoneyWithCurrency(cents, currency) {
    return `${formatMoney(cents, currency)} ${currency || 'USD'}`;
  }

  function imageUrl(src) {
    if (!src) return '';
    if (src.indexOf('//') === 0) return window.location.protocol + src;
    return src;
  }

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function uploadedImageUrl(value) {
    if (typeof value !== 'string' || !value || /[\s\\#<>"'\u0000-\u001f\u007f]/.test(value)) return '';
    const candidate = value.startsWith('//') ? 'https:' + value : value;
    if (/^https:\/\/viralflows\.net\/shopify-app\/customer-previews\/[a-f0-9]{64}\.jpg$/.test(candidate)) return candidate;
    const prefix = 'https://cdn.shopify.com/s/files/1/1002/6575/4900/uploads/';
    if (!candidate.startsWith(prefix)) return '';
    const path = candidate.split('?')[0].toLowerCase();
    if (/\.\.|%2e|%2f|%5c|%25/.test(path) || !/\.(png|jpe?g|webp)$/.test(path)) return '';
    try {
      const parsed = new URL(candidate);
      if (parsed.origin !== 'https://cdn.shopify.com' || parsed.username || parsed.password || parsed.hash || !parsed.pathname.startsWith('/s/files/1/1002/6575/4900/uploads/')) return '';
    } catch (_) { return ''; }
    return candidate;
  }

  function designPreview(item) {
    const properties = item && item.properties;
    return uploadedImageUrl(properties && (properties['_HAH design preview'] || properties['Design preview']));
  }

  function previewMigration(item) {
    const properties = item && item.properties;
    if (!properties || typeof properties !== 'object' || Array.isArray(properties) || typeof item.key !== 'string' ||
        !item.key || !Number.isInteger(item.quantity) || item.quantity < 1 || !properties['Design preview']) return null;
    const preview = uploadedImageUrl(properties['Design preview']);
    if (!preview || (properties['_HAH design preview'] && uploadedImageUrl(properties['_HAH design preview']) !== preview)) return null;
    const saved = properties['_HAH saved design'];
    if (saved) {
      if (typeof saved !== 'string' || !/^[a-f0-9]{64}$/.test(saved) || preview !== 'https://viralflows.net/shopify-app/customer-previews/' + saved + '.jpg') return null;
    } else {
      try {
        const snapshot = JSON.parse(properties['_HAH design data']);
        if (!snapshot || !['hah-layered-design/v1', 'hah-photo-name/v1'].includes(snapshot.schema) ||
            typeof snapshot.designId !== 'string' || snapshot.designId !== properties['Design reference']) return null;
      } catch (_) { return null; }
    }
    // Shopify replaces the properties object. Preserve every other customer and
    // internal property, and address the exact current line key rather than its position.
    const next = { ...properties, '_HAH design preview': preview };
    delete next['Design preview'];
    return { id: item.key, quantity: item.quantity, properties: next };
  }

  // Both the server-rendered cart page and refreshed drawer use this fallback.
  function previewImageFailed(event) {
    const image = event.target;
    if (!image || image.tagName !== 'IMG' || !image.hasAttribute('data-hah-cart-preview')) return;
    image.removeAttribute('data-hah-cart-preview');
    const fallback = image.getAttribute('data-hah-cart-fallback');
    if (fallback) { image.removeAttribute('srcset'); image.src = fallback; image.alt = image.getAttribute('data-hah-cart-fallback-alt') || 'Product image'; }
  }
  document.addEventListener('error', previewImageFailed, true);
  document.querySelectorAll('img[data-hah-cart-preview]').forEach((image) => {
    if (image.complete && !image.naturalWidth) previewImageFailed({ target: image });
  });

  function itemMeta(item) {
    const parts = [];

    if (Array.isArray(item.options_with_values)) {
      item.options_with_values.forEach((option) => {
        if (!option || !option.name || !option.value || option.value === 'Default Title') return;
        parts.push(`<span>${escapeHtml(option.name)}: ${escapeHtml(option.value)}</span>`);
      });
    } else if (item.variant_title && item.variant_title !== 'Default Title') {
      parts.push(`<span>${escapeHtml(item.variant_title)}</span>`);
    }

    if (item.properties) {
      const preview = designPreview(item);
      if (item.properties['_HAH design preview'] || item.properties['Design preview']) {
        parts.push(preview ? `<span><a href="${escapeHtml(preview)}" target="_blank" rel="noopener noreferrer">View your design</a></span>` : '<span>Design preview unavailable</span>');
      }
      Object.entries(item.properties).forEach(([key, value]) => {
        if (!value || key.charAt(0) === '_' || key === 'Design preview') return;
        const upload = uploadedImageUrl(value);
        if (upload) {
          parts.push(`<span>${escapeHtml(key)}: <a href="${escapeHtml(upload)}" target="_blank" rel="noopener noreferrer">View uploaded image</a></span>`);
        } else parts.push(`<span>${escapeHtml(key)}: ${escapeHtml(value)}</span>`);
      });
    }

    return parts.length ? `<div class="hah-cart-item-meta">${parts.join('')}</div>` : '';
  }

  function renderCart(cart) {
    drawer.setAttribute('aria-busy', 'false');
    currentCart = cart;
    const currency = cart.currency || 'USD';

    if (countNode) countNode.textContent = cart.item_count || 0;
    if (labelNode) labelNode.textContent = cart.item_count === 1 ? 'item' : 'items';
    if (subtotalNode) subtotalNode.textContent = formatMoneyWithCurrency(cart.total_price, currency);

    document.querySelectorAll('[data-hah-cart-count-display]').forEach((node) => {
      node.textContent = cart.item_count || 0;
    });

    if (checkoutNode) {
      checkoutNode.style.display = cart.item_count > 0 ? 'inline-flex' : 'none';
    }

    if (!itemsNode) return;
    if (!cart.items || cart.items.length === 0) {
      itemsNode.innerHTML = '<div class="hah-cart-empty">Your cart is currently empty.</div>';
      return;
    }

    itemsNode.innerHTML = cart.items.map((item, index) => {
      const line = index + 1;
      const title = item.product_title || item.title || 'Product';
      const price = formatMoney(item.final_line_price || item.line_price, currency);
      const originalImage = imageUrl(item.image);
      const preview = designPreview(item);
      const img = preview || originalImage;
      const url = item.url || '#';

      return `
        <article class="hah-cart-item">
          <a class="hah-cart-item-media" href="${escapeHtml(url)}">
            ${img ? `<img src="${escapeHtml(img)}" alt="${escapeHtml(preview ? 'Your personalized design — ' + title : title)}" loading="lazy"${preview ? ` data-hah-cart-preview data-hah-cart-fallback="${escapeHtml(originalImage)}" data-hah-cart-fallback-alt="${escapeHtml(title)}"` : ''}>` : ''}
          </a>
          <div>
            <a class="hah-cart-item-title" href="${escapeHtml(url)}">${escapeHtml(title)}</a>
            ${itemMeta(item)}
            <div class="hah-cart-row-actions">
              <div class="hah-cart-qty" aria-label="Quantity">
                <button type="button" data-hah-cart-qty="${line}" data-hah-cart-delta="-1">-</button>
                <span>${item.quantity}</span>
                <button type="button" data-hah-cart-qty="${line}" data-hah-cart-delta="1">+</button>
              </div>
              <button class="hah-cart-remove" type="button" data-hah-cart-remove="${line}">remove</button>
            </div>
          </div>
          <div class="hah-cart-item-price">${price}</div>
        </article>
      `;
    }).join('');
    if (cart.items.some((item) => previewMigration(item) && previewMigrationAttempts.get(item.key) === 'failed')) {
      itemsNode.innerHTML += '<p class="hah-cart-preview-notice" role="status">Your items are still in your cart. The design preview display could not be updated. <a href="' + escapeHtml(cartEndpoint('cart')) + '" data-hah-cart-page>Reload your cart</a>.</p>';
    }
  }

  async function migratePreviewProperties(cart, operation) {
    const maxChanges = cart.items.length;
    for (let count = 0; count < maxChanges; count++) {
      if (pendingRead !== operation || readSerial !== operation.serial || pendingChange) break;
      const item = cart.items.find((row) => !previewMigrationAttempts.has(row.key) && previewMigration(row));
      if (!item) break;
      const payload = previewMigration(item);
      previewMigrationAttempts.set(item.key, 'started');
      const controller = typeof AbortController === 'function' ? new AbortController() : null;
      let timer, failed = false;
      const previousCart = cart;
      const request = Promise.resolve().then(async () => {
        const response = await fetch(cartEndpoint('cart/change.js'), {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(payload), signal: controller ? controller.signal : undefined
        });
        if (!response.ok) throw new Error('Unable to update the design preview display.');
        const result = await response.json();
        if (!validCart(result)) throw new Error('Unable to confirm the cart update.');
        const confirmed = result.items.some((row) => row.properties && !row.properties['Design preview'] &&
          Object.entries(payload.properties).every(([key, value]) => JSON.stringify(row.properties[key]) === JSON.stringify(value)));
        if (!confirmed) throw new Error('The design preview update was not confirmed.');
        return result;
      });
      const change = Promise.race([request, new Promise((_, reject) => {
        timer = window.setTimeout(() => {
          if (controller) controller.abort();
          reject(new Error('Design preview update timed out.'));
        }, 10000);
      })]).then((result) => {
        previewMigrationAttempts.set(item.key, 'complete');
        previewMigrationCommits++;
        return result;
      }).catch(() => {
        // A timeout may have reached Shopify. Never send the mutation again in
        // this page session; a fresh cart read can reconcile the returned state.
        failed = true; previewMigrationAttempts.set(item.key, 'failed');
        return previousCart;
      }).finally(() => {
        window.clearTimeout(timer);
        if (pendingChange === change) pendingChange = null;
      });
      pendingChange = change;
      cart = await change;
      if (failed) break;
    }
    return cart;
  }

  function fetchCart() {
    if (pendingChange) {
      // A hung mutation must not bypass the cart drawer's bounded read wait.
      const change = pendingChange, serial = readSerial;
      if (pendingChangeRead && pendingChangeRead.change === change && pendingChangeRead.serial === serial) return pendingChangeRead.promise;
      const waiting = { change, serial, promise: null };
      let timer;
      cartState('Updating cart…', false);
      waiting.promise = Promise.race([change, new Promise((_, reject) => {
        timer = window.setTimeout(() => reject(new Error('Cart change is still unconfirmed.')), 10000);
      })]).then(() => serial === readSerial ? fetchCart() : undefined).catch((error) => {
        if (serial === readSerial) cartState('We could not confirm the cart change. Check your cart before trying again.', true);
        throw error;
      }).finally(() => {
        window.clearTimeout(timer);
        if (pendingChangeRead === waiting) pendingChangeRead = null;
      });
      pendingChangeRead = waiting;
      return waiting.promise;
    }
    if (pendingRead) return pendingRead.promise;
    const operation = { serial: ++readSerial, controller: typeof AbortController === 'function' ? new AbortController() : null, promise: null };
    pendingRead = operation;
    cartState('Loading cart…', false);
    let timer;
    const request = Promise.resolve().then(async () => {
      const response = await fetch(cartEndpoint('cart.js'), {
        headers: { Accept: 'application/json' },
        cache: 'no-store',
        signal: operation.controller ? operation.controller.signal : undefined
      });
      if (!response.ok) throw new Error('Unable to load cart.');
      const cart = await response.json();
      if (!validCart(cart)) throw new Error('Unable to confirm cart contents.');
      return cart;
    });
    operation.promise = Promise.race([request, new Promise((_, reject) => {
      timer = window.setTimeout(() => {
        if (operation.controller) operation.controller.abort();
        reject(new Error('Cart loading timed out.'));
      }, 10000);
    })]).then((cart) => {
      window.clearTimeout(timer);
      return migratePreviewProperties(cart, operation);
    }).then((cart) => {
      if (pendingRead === operation && readSerial === operation.serial) renderCart(cart);
      return cart;
    }).catch((error) => {
      if (pendingRead === operation && readSerial === operation.serial) cartState('We could not load your cart. Check it before adding again.', true);
      throw error;
    }).finally(() => {
      window.clearTimeout(timer);
      if (pendingRead === operation) pendingRead = null;
    });
    return operation.promise;
  }

  function openDrawer() {
    drawer.classList.add('is-open');
    backdrop.classList.add('is-open');
    backdrop.hidden = false;
    drawer.inert = false;
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('hah-cart-lock');
  }

  function closeDrawer() {
    drawer.classList.remove('is-open');
    backdrop.classList.remove('is-open');
    drawer.inert = true;
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('hah-cart-lock');
    window.setTimeout(() => {
      if (!backdrop.classList.contains('is-open')) backdrop.hidden = true;
    }, 240);
  }

  function changeLine(line, quantity) {
    if (pendingChange) return pendingChange;
    invalidateRead();
    cartState('Updating cart…', false);
    const serial = readSerial;
    const change = Promise.resolve().then(async () => {
      const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line, quantity })
      });
      if (!response.ok) throw new Error('Unable to update cart.');
      const cart = await response.json();
      if (!validCart(cart)) throw new Error('Unable to confirm cart contents.');
      if (serial === readSerial) renderCart(cart);
      return cart;
    }).catch((error) => {
      if (serial === readSerial) cartState('We could not confirm the cart change. Check your cart before trying again.', true);
      throw error;
    }).finally(() => { if (pendingChange === change) pendingChange = null; });
    pendingChange = change;
    return change;
  }

  async function updateNote(note) {
    await fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({ note })
    });
  }

  function refreshAndOpenDrawer() {
    openDrawer();
    return fetchCart();
  }

  document.addEventListener('hah:cart:open', () => {
    // This event follows a confirmed addition. An older GET cannot include it.
    invalidateRead();
    refreshAndOpenDrawer().catch(() => {});
  });

  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('.hah-aprin-card-form');
    if (!form) return;
    event.preventDefault();
    if (pendingAdds.has(form) || uncertainAdds.has(form)) return;
    pendingAdds.add(form);
    const button = form.querySelector('.hah-aprin-add-to-cart');
    const wasDisabled = button ? button.disabled : false;
    button?.setAttribute('aria-busy', 'true');
    if (button) button.disabled = true;
    let confirmed = false;
    let definitiveFailure = false;
    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST', body: new FormData(form), headers: { Accept: 'application/json' }
      });
      definitiveFailure = !response.ok && response.status < 500;
      if (!response.ok) throw new Error('Unable to add item.');
      confirmed = true;
      invalidateRead();
      await refreshAndOpenDrawer();
    } catch (error) {
      // A failed refresh never means the successful addition should be repeated.
      // A failed POST transport is also uncertain: use the cart page to reconcile.
      if (!confirmed) {
        if (!definitiveFailure) uncertainAdds.add(form);
        invalidateRead();
        openDrawer();
        cartState(definitiveFailure ? 'This item could not be added. Check its options and availability.' : 'We could not confirm the addition. Check your cart before adding again.', true);
      }
    } finally {
      pendingAdds.delete(form);
      button?.removeAttribute('aria-busy');
      if (button) button.disabled = definitiveFailure || confirmed ? wasDisabled : true;
    }
  });

  document.addEventListener('click', async (event) => {
    const closeButton = event.target.closest('[data-hah-cart-close]');
    if (closeButton) {
      closeDrawer();
      return;
    }

    const cartLink = event.target.closest('a[href="/cart"], a[href$="/cart"]');
    if (cartLink && !cartLink.hasAttribute('data-hah-cart-page') && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey) {
      event.preventDefault();
      await refreshAndOpenDrawer().catch(() => {});
      return;
    }

    const qtyButton = event.target.closest('[data-hah-cart-qty]');
    if (qtyButton) {
      const line = Number(qtyButton.dataset.hahCartQty);
      const delta = Number(qtyButton.dataset.hahCartDelta);
      const item = currentCart?.items?.[line - 1];
      if (!item) return;
      await changeLine(line, Math.max(0, item.quantity + delta)).catch(() => {});
      return;
    }

    const removeButton = event.target.closest('[data-hah-cart-remove]');
    if (removeButton) {
      if (!currentCart || pendingChange) return;
      await changeLine(Number(removeButton.dataset.hahCartRemove), 0).catch(() => {});
    }
  });

  noteToggle?.addEventListener('click', () => {
    noteNode?.classList.toggle('is-open');
    if (noteNode?.classList.contains('is-open')) noteNode.focus();
  });

  noteNode?.addEventListener('change', () => {
    updateNote(noteNode.value);
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && drawer.classList.contains('is-open')) {
      closeDrawer();
    }
  });

  // The full cart can go straight to checkout without opening the drawer.
  // Prepare its existing design properties before its native quantity/checkout
  // form can submit. A confirmed property change may merge identical lines, so
  // reload that page once to keep its server-rendered line indices accurate.
  const fullCartForm = document.querySelector('.hah-cart-page .hah-cart-form');
  if (fullCartForm) {
    let preparingCartPage = true, reloadingCartPage = false;
    const previouslyInert = fullCartForm.inert, before = previewMigrationCommits;
    const notice = document.createElement('p');
    notice.className = 'hah-cart-preview-notice'; notice.setAttribute('role', 'status');
    notice.textContent = 'Preparing your saved cart…';
    fullCartForm.parentNode.insertBefore(notice, fullCartForm);
    fullCartForm.inert = true; fullCartForm.setAttribute('aria-busy', 'true');
    fullCartForm.addEventListener('submit', (event) => {
      if (preparingCartPage) event.preventDefault();
    });
    fetchCart().then((cart) => {
      if (previewMigrationCommits > before) { reloadingCartPage = true; window.location.reload(); return; }
      if (cart && cart.items.some((item) => previewMigration(item) && previewMigrationAttempts.get(item.key) === 'failed')) {
        notice.textContent = 'Your items are still saved. Reload this page to retry updating the design preview display.';
      } else notice.remove();
    }).catch(() => {
      reloadingCartPage = false;
      notice.textContent = 'Your cart is still saved. Reload this page if its display needs refreshing.';
    }).finally(() => {
      if (reloadingCartPage) return;
      preparingCartPage = false; fullCartForm.inert = previouslyInert;
      fullCartForm.removeAttribute('aria-busy');
    });
  }

  window.HAHCartDrawer = {
    open: refreshAndOpenDrawer,
    close: closeDrawer,
    refresh: fetchCart
  };
})();
